import { NgModule } from '@angular/core';
import { ComunModule } from './comun.module';
import { RouterModule, Routes } from '@angular/router';
import { paths } from './services/sesion.service';
import { OfflineGuard } from './offline.guard';



const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    data: { idioma: 'es' }
  },
  {
    path: 'Home',
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { idioma: 'en' }
  },
  {
    path: 'Iniciação',
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.homeBusiness.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { idioma: 'es', empresas: true }
  },
  {
    path: paths.homeBusiness.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { idioma: 'en', empresas: true }
  },
  {
    path: paths.homeBusiness.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    data: { idioma: 'pt', empresas: true }
  },
  {
    path: paths.modificarEnvio.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/modify-shipping.module').then(m => m.ModifyShippingModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.modificarEnvio.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/modify-shipping.module').then(m => m.ModifyShippingModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.modificarEnvio.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/modify-shipping.module').then(m => m.ModifyShippingModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.noData.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./no-data/no-data.module').then(m => m.NoDataModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.noData.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./no-data/no-data.module').then(m => m.NoDataModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.noData.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./no-data/no-data.module').then(m => m.NoDataModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.withoutModification.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./without-modification/without-modification.module').then(m => m.WithoutModificationModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.withoutModification.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./without-modification/without-modification.module').then(m => m.WithoutModificationModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.withoutModification.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./without-modification/without-modification.module').then(m => m.WithoutModificationModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.changesMade.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./changes-made/changes-made.module').then(m => m.ChangesMadeModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.changesMade.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./changes-made/changes-made.module').then(m => m.ChangesMadeModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.changesMade.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./changes-made/changes-made.module').then(m => m.ChangesMadeModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.proofDeliveryTerms.es,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/proof-delivery-terms/proof-delivery-terms.module').then(m => m.ProofDeliveryTermsModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.proofDeliveryTerms.en,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/proof-delivery-terms/proof-delivery-terms.module').then(m => m.ProofDeliveryTermsModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.proofDeliveryTerms.pt,
    canActivateChild: [OfflineGuard],
    canActivate: [OfflineGuard],
    loadChildren: () => import('./modify-shipping/proof-delivery-terms/proof-delivery-terms.module').then(m => m.ProofDeliveryTermsModule),
    data: { idioma: 'pt' }
  },
  {
    path: paths.offline.es,
    loadChildren: () => import('./app-offline/app-offline.module').then(m => m.AppOfflineModule),
    data: { idioma: 'es' }
  },
  {
    path: paths.offline.en,
    loadChildren: () => import('./app-offline/app-offline.module').then(m => m.AppOfflineModule),
    data: { idioma: 'en' }
  },
  {
    path: paths.offline.pt,
    loadChildren: () => import('./app-offline/app-offline.module').then(m => m.AppOfflineModule),
    data: { idioma: 'pt' }
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    ComunModule,
    RouterModule.forRoot(routes),
  ],
  declarations: []
})
export class AppRoutingModule { }
